export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Colonnes contestées"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réinitialiser"])}
}